<section class="nw_service_th" *ngIf="!loader && businessListData.length > 0">
    <div class="service_se">
        <div class="heading_sert">
            <h3>All customers</h3>
        </div>
        <div class="chip_services_list">
            <mat-chip-list>
                <mat-chip (click)="selectBusiness(i)" *ngFor="let item of businessListData; let i = index" [ngClass]="{'Graceful-box-active': item.isSelected == 1}">{{item.name}}</mat-chip>
                
            </mat-chip-list>
        </div>
    </div>

    <div class="service_create_sd">
    <div class="row">
        <div class="col-sm-9">
           <div class="serv_heading">
            <h3>All customers of {{selectedBusiness.name}}</h3>
            <p>{{selectedBusiness.address_line}}</p>

        </div>
      </div>
      <div class="col-sm-3">
        <div class="select_thth">
        <div class="create_btn_sd">
            <button mat-flat-button color="primary" (click)="addcustomer()" >
                <mat-icon>add</mat-icon> 
                Add customer
            </button>
        </div>
        </div>
      </div>
    </div>
    </div>

  <div style="margin-bottom: 10px;" *ngIf="!loader">
    <div class="search-field" style="margin-bottom: 10px;">
      <mat-form-field appearance="outline" class="me-2 w-100">
        <mat-label>{{ 'customers.search_label' | translate }}</mat-label>
        <input
        [formControl]="searchString"
         
          matInput
          placeholder="{{ 'customers.search_placeholder' | translate }}"
          (keyup)="searchServiceData()"
        />
        <button
          mat-button
          *ngIf="!searchString.value"
          matSuffix
          mat-icon-button
          aria-label="Clear"
        >
          <mat-icon>search</mat-icon>
        </button>
        <button
        mat-button
        *ngIf="searchString.value"
        matSuffix
        mat-icon-button
        aria-label="Clear"
        (click)="reset()"
      >
        <mat-icon>close</mat-icon>
      </button>
      </mat-form-field>

      
    </div>
       <!-- <sm-title-bar pageSubTitle="Services" [showBackButton]="true"></sm-title-bar> -->
    <div class="rounded-3 bg-light" *ngIf="!loader && customersData.length > 0">
      <sm-data-table [columnHeaders]="tableDisplayColumns" [dataSource]="customersData" [showMenuButton]="true" [menuDropdownTemplate]="menuTemplate"
         [showPagination]="true" [showImageColumn]="true"  [imageTemplate]="image" [itemsPerPage]="25">
      </sm-data-table>
    </div>
  </div>

    <ng-template #menuTemplate let-rowvalue>
    <button mat-menu-item (click)="viewdetails(rowvalue)">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button>
    <button mat-menu-item (click)="createInvoice(rowvalue)" *ngIf="isAccessForEmployeeInvoice">
      <mat-icon class="material-icons-outlined">playlist_add</mat-icon>
      <span>Create invoice</span>
    </button>
    <!-- <button mat-menu-item (click)="openAllBookings(rowvalue)">
      <mat-icon>list</mat-icon>
      <span>{{ 'customers.op1' | translate }}</span>
    </button>
    <button mat-menu-item (click)="openAllPayments(rowvalue)">
      <mat-icon class="material-icons-outlined">receipt</mat-icon>
      <span>See all payments</span>
    </button> -->
    <button mat-menu-item (click)="openDueBookings(rowvalue)">
      <mat-icon class="material-icons-outlined">pending_actions</mat-icon>
      <span>See due bills/invoices</span>
    </button>
   <!-- <button mat-menu-item (click)="openwallemoney(rowvalue)">
            <mat-icon class="material-icons-outlined">wallet</mat-icon>
            <span>Wallet money</span>
          </button>
               <button mat-menu-item (click)="openrewardpoint(rowvalue)">
      <mat-icon class="material-icons-outlined">card_giftcard</mat-icon>
      <span>Reward points</span>
    </button> -->
    <button mat-menu-item (click)="openPaymentIntimation(rowvalue)" *ngIf="rowvalue.total_due > 0 && selectedBusiness.is_owner == 1">
      <mat-icon class="material-icons-outlined">share</mat-icon>
      <span>{{ 'customers.op3' | translate }}</span>
    </button>
    <!-- <button mat-menu-item (click)="editCustomer(rowvalue)" *ngIf="selectedBusiness.is_owner == 1">
      <mat-icon class="material-icons-outlined">edit</mat-icon>
      <span>Edit Customer</span>
    </button>
    <button mat-menu-item (click)="deleteCustomer(rowvalue)" *ngIf="selectedBusiness.is_owner == 1">
      <mat-icon class="material-icons-outlined">delete</mat-icon>
      <span>Delete Customer</span>
    </button> -->
    <!-- <button mat-menu-item (click)="customerviewdetails()">
      <mat-icon class="material-icons-outlined">info</mat-icon>
      <span>View details</span>
    </button> -->
  </ng-template>
  

    <ng-template #image let-objValue>
    <img
      [src]="
        objValue['image_thumb_url'] !== null && objValue['image_thumb_url'] !== 'null' && objValue['image_thumb_url'] !== ''
          ? objValue['image_thumb_url']
          : './assets/images/photo.png'
      "
      class="img-fluid rounded-circle"
    />
  </ng-template>


    <!-- placeholder html start -->
    <div class="placeholder_started" *ngIf="!loader && customersData.length == 0">
      <div class="row">
        <div class="col-sm-4" *ngIf="selectedValue == '0'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer to show.</mat-card-title>
               <mat-card-content>Creating booking and invoice adds customers automatically to your business. You can add customers manually too.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary" (click)="addcustomer()">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '1'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No customer with dues.</mat-card-title>
               <mat-card-content>The customers with unpaid invoices and dues in payments, will show here. Apart from the due data and other information, you can send them payment intimation too.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4" *ngIf="selectedValue == '2'">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/customer-1.jpg">
               </div>
               <mat-card-title>No long absent customer yet.</mat-card-title>
               <mat-card-content>The customers who haven't visited the business for long, will appear here. You can get their details, contact them, send them personalized message with offers.
              </mat-card-content>
               <!-- <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary">
                     <mat-icon>add</mat-icon>
                     Add customer
                  </button>
               </div> -->
               </div>
            </mat-card>
         </div>
        </div>
        <div class="col-sm-4">
          <div class="dashboard_new">
            <mat-card>
                <div class="upload_sectio">
               <div class="icm_img">
                  <img src="./assets/images/helpsupport.png">
               </div>
               <mat-card-title>Facing any issue?</mat-card-title>
               <mat-card-content>For any difficulties in creating a new customer or if there's any issue with customer data, contact the support team.
              </mat-card-content>
               <div class="watch_vc_btn">
                  <button mat-stroked-button color="primary"  (click)="opencontact()">
                     <mat-icon>support_agent</mat-icon>
                     Contact support 
                  </button>
               </div>
               </div>
            </mat-card>
         </div>
        </div>
      </div>
</div> 
<!-- placeholder html end -->

</section>
<section class="nw_service_th" *ngIf="!loader && businessListData.length == 0">
    <div class="">
        <div class="heading_sert">
            <h3>All customers</h3>
        </div>
    </div>

       <!-- Placeholder design html start -->
       <div class="placeholder_started__business">
        <div class="row">
          <div class="col-sm-4" *ngIf="!isEmployeeAndHasBusinessButDoesNotHaveAccess">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/business-create.png" style="width: 110px;">
                 </div>
                 <mat-card-title>No business added yet.</mat-card-title>
                 <mat-card-content>To add your customers you need to create a business first. Customers will be added under that business.
                </mat-card-content>
                 <div class="create_btnyh">
                    <button mat-flat-button color="primary" (click)="selectcountry()">
                        <mat-icon>add</mat-icon> 
                        Create a business
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
         <div class="col-sm-4" *ngIf="isEmployeeAndHasBusinessButDoesNotHaveAccess">
                <div class="dashboard_new" >
                  <mat-card appearance="outlined" style="">
                      <div class="upload_sectio">
                     <div class="icm_img">
                        <img src="./assets/images/business-create.png" style="width: 110px;">
                     </div>
                     <mat-card-title>Access denied.</mat-card-title>
                     <mat-card-content> Business owner with valid premium business subscription or an active employee with permission can access this section. Check current plans. Recharge pack if expired.
                    </mat-card-content>
                     
                     </div>
                  </mat-card>
               </div>
              </div>
          <div class="col-sm-4">
            <div class="dashboard_new">
              <mat-card>
                  <div class="upload_sectio">
                 <div class="icm_img">
                    <img src="./assets/images/helpsupport.png">
                 </div>
                 <mat-card-title>Having any issue?</mat-card-title>
                 <mat-card-content>For any difficulties in adding customers or if there's any issue while adding customers, contact our support team.
                </mat-card-content>
                 <div class="watch_vc_btn">
                    <button mat-stroked-button color="primary" (click)="opencontact()">
                       <mat-icon>support_agent</mat-icon>
                       Contact support
                    </button>
                 </div>
                 </div>
              </mat-card>
           </div>
          </div>
        </div>
    
      </div>
      <!-- Placeholder design html start -->
    
      
</section>